import fetch from 'isomorphic-unfetch'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import getUrl from './url'

export default function request(url: RequestInfo, options?: RequestInit) {
  return new Promise((resolve, reject) => {
    const newOptions: RequestInit = {
      credentials: 'include',
      ...options,
    }
    if (newOptions.method === 'POST' || newOptions.method === 'PUT') {
      if (newOptions.body instanceof FormData) {
        newOptions.headers = {
          Accept: 'application/json',
          ...newOptions.headers,
        }
      } else {
        newOptions.headers = {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
          ...newOptions.headers,
        }
      }
    }
    fetch(url, newOptions)
      .then(response => {
        if (response.ok) {
          return response
        } else {
          reject(response)
          throw response
        }
      })
      .then(response => response.json())
      .then(response => resolve(response))
      .catch(reject)
  })
}

request.get = (url: string, data?: object, options?: RequestInit) => {
  let newUrl = getUrl(url)
  if (data) {
    newUrl += `${url.indexOf('?') === -1 ? '?' : '&'}${serializeObject(data)}`
  }
  return request(newUrl, options)
}

request.post = (url: string, data?: object, options?: RequestInit) => {
  const newOptions: Partial<RequestInit> = {
    method: 'POST',
    ...options,
  }
  if (data) {
    newOptions.body = serializeObject(data)
  }
  return request(getUrl(url), newOptions)
}
